import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Certificate Management</Typography>

      <p>When an Apple pass is created it must be signed with a Signing Certiticate. Every subsequent update must be signed with the same certificate 
        (or a new certificate with the same Apple pass type ID from the same Apple developer account). Similarly, Android passes are signed with Google 
        credentials which must refer to the same account.
      </p>

      <p>This means that switching between Certificate sources is non-trivial.</p>

      <p>We suggest that you use our shared Certificates for initial testing and evaluation and for live passes for small organisations only.</p>

      <p>Apple and Google can suspend Certificates if they deem that they are beign misused - for example, but sending pass updates / notifications too frequently - 
        hence we have strict limilations on how often you can do this with a shared certificate. This is necessary to prevent one user affecting other users that are 
        assigned to the same certificate. You will be limited to ONE update OR notification per pass per day. </p>

      <p>Ideally you will obtain and manage your own certificates from your own Apple and Google developer accounts. (There is a fee for this, currently (2026) £79/year 
        for Apple and £25 one-off fee for Google). However, if you use your own certificate we will not impose any restrictions. Hence this is the ideal option 
        for most users. You will be prompted to update your Apple certificate very 6 months. This is a manual process where a human has to log into your Apple 
        account and issue a new certificate.</p>

      <p>We also offer A Private certificate service for a monthly fee. If you do not wish to have your own Apple and Google developer accounts. We will issue a 
        private certificate from our developer accounts. Since there is still a risk to our other certificates from abuse with excessive updates / notifications, 
        we will still impose a limit, but it is higher than our shared certirticate limit. You will be limited to FIVE updates OR notifications per pass per day.</p>

    </div>
  )
}

export default HelpText